/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default function getRandomId() {
    return Math.random().toString(36).substring(2, 10);
}